import React from 'react'
import { BrowserRouter as Routers } from "react-router-dom";
import Layout from '../components/Layout';
import PublicRoutes from './PublicRoutes';

export default function Router({store, exportStore}) {
  return (
    <>
      <>
      <Routers>
        <Layout>
          <PublicRoutes store={store} exportStore={exportStore} />
        </Layout>
      </Routers>
    </>
    </>
  )
}
